import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    AlendumBfCategory,
    CreateAlendumBfCategoryInput,
    DeleteAlendumBfCategoryInput,
    UpdateAlendumBfCategoryInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class AlendumBfCategoryService {
    constructor() {}
    private amplifyClient = generateClient();

    async getAlendumBfCategory(id: string): Promise<AlendumBfCategory> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getAlendumBfCategory,
                    variables: {
                        id
                    }
                })
            ).data.getAlendumBfCategory;
            if (data) return data as AlendumBfCategory;
        } catch (error) {
            console.error('Error getAlendumBfCategory:', error);
            return null;
        }
    }

    async listAlendumBfCategories(): Promise<AlendumBfCategory[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listAlendumBfCategories
                })
            ).data.listAlendumBfCategories.items;
            if (data) return data as AlendumBfCategory[];
        } catch (error) {
            console.error('Error listAlendumCategories:', error);
            return null;
        }
    }

    async listAlendumBfCategoryByAlendumCategory(
        alendumCategoryId: string
    ): Promise<AlendumBfCategory[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.AlendumBfCategoryByAlendumCategory,
                    variables: {
                        alendumCategoryId
                    }
                })
            ).data.AlendumBfCategoryByAlendumCategory.items;
            if (data) return data as AlendumBfCategory[];
        } catch (error) {
            console.error('Error listAlendumCategories:', error);
            return null;
        }
    }

    async createAlendumBfCategory(
        input: CreateAlendumBfCategoryInput
    ): Promise<AlendumBfCategory> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createAlendumBfCategory,
                    variables: {
                        input
                    }
                })
            ).data.createAlendumBfCategory;
            if (date) return date as AlendumBfCategory;
        } catch (error) {
            console.error('Error creating AlendumCategory:', error);
            return null;
        }
    }

    async updateAlendumBfCategory(
        input: UpdateAlendumBfCategoryInput
    ): Promise<AlendumBfCategory> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateAlendumBfCategory,
                    variables: {
                        input
                    }
                })
            ).data.updateAlendumBfCategory;
            if (date) return date as AlendumBfCategory;
        } catch (error) {
            console.error('Error creating AlendumBfCategory:', error);
            return null;
        }
    }

    async deleteAlendumBfCategory(
        input: DeleteAlendumBfCategoryInput
    ): Promise<AlendumBfCategory> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteAlendumBfCategory,
                    variables: {
                        input
                    }
                })
            ).data.deleteAlendumBfCategory;
            if (date) return date as AlendumBfCategory;
        } catch (error) {
            console.error('Error creating AlendumBfCategory:', error);
            return null;
        }
    }
}
